import { FC } from 'react'
import { IJobBase } from '../../../types'
import { JobAttributes } from '../JobAttributes'
import { JobItemContentLabel } from '../JobItemContentLabel'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobItemContent: FC<Props> = ({ job }) => {
  return (
    <>
      <div className={styles.title}>{job?.title}</div>
      <div className={styles.label}>
        <JobItemContentLabel job={job} />
      </div>
      <div className={styles.attributes}>
        <JobAttributes job={job} />
      </div>
    </>
  )
}
